export const initialState = {
    session: {
        loader: true,
        categoryTitle: "NUESTROS PRODUCTOS",
        showCart: false,
        toast: {
            show: false,
            message: "",
        },
        cart: [],
    },
    flags: {},
};
